<template>
    <div class="scrollable-container">
        <Navbar/>
        <div class="p-5 gray-background">
          <div class="card p-5 shadow">
              <div class="row">
                  <div class="col-md-12 text-center">
                      <h3>Iniciar solicitud</h3>
                      <h5>Por favor ingresa los siguientes datos</h5>
                  </div>
                  <div class="card p-4 mt-3">
                      <div class="row">
                          <form @submit.prevent="submitForm" class="row">
                              <div class="col-md-5">
                                  <label class="form-label">Email</label>
                                  <input type="email" class="form-control" id="validationCustom01" v-model="email" required>
                                  <div class="invalid-feedback">
                                      Por favor, proporciona un email valido.
                                  </div>
                              </div>
                              <div class="col-md-4">
                                  <label  class="form-label">Folio de Carta</label>
                                  <input type="number" class="form-control" id="validationCustom01" v-model="folio" required>
                                  <div class="invalid-feedback">
                                      Por favor, proporciona un Folio.
                                  </div>
                              </div>
          
                              <div class="col-md-3">
                              <button class="btn btn-primary mt-3 float-right col-11" type="submit" style="border-radius: 15px;"><i class="fas fa-search mr-2"></i>Buscar</button>
                              </div>
                          </form>
                      </div>
                  </div>
              </div>
      
              <MostrarInformacion
              v-if="step === 1"
              :getRequisitos="getRequisitos"
              :folioCarta.sync="datosSolicitud.Folio"
              :hospital.sync="datosSolicitud.NombreHospital"
              :poliza.sync="datosSolicitud.NumeroPoliza"
              :ramo.sync="datosSolicitud.RAMO"
              :producto.sync="datosSolicitud.NombreProducto"
              :movimiento.sync="datosSolicitud.MOVIMIENTO"
              :nombres.sync="datosSolicitud.NombreClienteUnico"
              :paterno.sync="datosSolicitud.ApellidoPaternoCUnico"
              :materno.sync="datosSolicitud.apellidoMaternoCUnico"
              :claveAgente.sync="datosSolicitud.DatosAgente"
              />
              <requisitos
              v-if="step === 2"
              :getDocument="getDocument"
              :uploadDocument="uploadDocument"
              :deleteDocument="deleteDocument"
              :listDocuments.sync="listDocuments"
              :catalogoTramite.sync="catalogoTramite"
              :catalogoDocumentosRequisitos="catalogoDocumentosRequisitos"
              />
              <div class="row" v-if="step === 2">
                <div class="col-md-12 text-center">
                    <button class="btn btn-primary col-3" style="border-radius: 15px;" @click="sendSolicitud"><i class="far fa-paper-plane mr-2"></i>Enviar solicitud</button>
                </div>
              </div>
          </div>
        </div>
        <MensajeModal 
        :Icon="icono"
        :Title="title"
        :Text="text"
        :ClassButton="classButton"
        :actionButton="actionButton"
        />
        <loading :isLoading="isLoading"></loading>

    </div>
</template>

<script>
import MostrarInformacion from './Pages/MostrarInformacion.vue';
import Requisitos from './Pages/requisitos.vue';
import Navbar from './Pages/Navbar.vue';
import MensajeModal from './Modals/mensajeModal.vue';
import Loading from './tools/loading.vue';



export default {
    components: {
        MostrarInformacion,
        Requisitos,
        MensajeModal,
        Loading,
        Navbar
    },
    data() {
    return {
      isLoading: false,
      //Modal validacion
      icono: 0,
      title: '',
      text: '',
      classButton: '',

      loadingIf: false,
      xmlValidation: false,
      actionB: false,
      email: '',
      folio: '',
      tipoTramite: '',
      tipoRequisito: '',
      rfcReceptor: '',
      UUID: '',
      step: 0,
      listDocumentsTemp: [],
      listDocuments: [],
      datosSolicitud: [],
      catalogoTramite: [],
      catalogoTramite: [],
      listDocumentosObligatorio: [],
    };
  },
  methods: {
    actionButton(){
        this.$modal.hide('mensaje')
        if (this.actionB == true) {
            window.location.reload()
        }

    },
    async submitForm() {
        this.isLoading = true;
        const payload = {
            metodo: "GETDATOSPORFOLIO",
            data: {
                Folio: this.folio,
            },
        };
        this.$store.dispatch("metodoPost", payload).then(() => {
        const info = this.$store.getters.getRespuestaREST;
        console.log(info);
        if (info.length <= 0) {
            console.log('entra info');
            this.$modal.show('mensaje')
            this.icono = 2
            this.title = 'Error!'
            this.text = 'No se encontro información para el folio: ' + this.folio + '. No corresponde a una cirugia programada.'
            this.classButton = 'btn btn-danger col-3'
            this.actionB = false;
            return;
        }
        
        this.step = 1;
        info[0].DatosAgente = info[0].ClaveAgente + ' - ' + info[0].NombreAgente
        this.datosSolicitud = info[0]
        })
        this.isLoading = false;
    },
    async catalogoDocumentosRequisitos(data) {
        this.isLoading = true;
        this.tipoRequisito = data;
        this.listDocuments= []
        const payload = {
            metodo: "GETREQUISITOS",
            data: {
                idRamo: this.datosSolicitud.IDRamo.toString(),
                idCatProducto: this.datosSolicitud.IDProducto.toString(),
                idCatMovimiento: '321',
                idCatTipoTramite: data.toString(),
                idCatTipoPersona: '1',
            },
        };
        this.$store.dispatch("metodoPost", payload).then(() => {
        const info = this.$store.getters.getRespuestaREST;
        info.map( (doc, i) => {
            this.listDocuments.push(doc.requisitoTramiteField.catRequisitoField)
        })
        this.isLoading = false;
        })
    },
    async catalogoTipoTramite() {
        this.isLoading = true;
        const payload = {
            metodo: "GETTIPOTRAMITE",
            data: {
                ClaveRamo: this.datosSolicitud.IDRamo,
                ClaveProducto: this.datosSolicitud.IDProducto,
                ClaveMovimiento: '321',
            },
        };
        this.$store.dispatch("metodoPost", payload).then(() => {
        const info = this.$store.getters.getRespuestaREST;
        this.catalogoTramite = info
        this.isLoading = false;
        })
    },
    getRequisitos(){
        this.step = 2;
        this.catalogoTipoTramite()
    },
    getDocument(event, idDocumento){
        const timestamp = new Date().getTime();
        event.target.files[0].idDocumento = idDocumento
        event.target.files[0].uniqueFileName = `${idDocumento}_${timestamp}`;
        this.listDocumentsTemp.push(event.target.files[0])

        // Resetear el valor del input file
      event.target.value = null;
    },
    uploadDocument(idDocumento){
        const index = this.listDocuments.findIndex(doc => doc.idField === idDocumento);
    if (index !== -1) {
        const documentoTemp = this.listDocumentsTemp.find(docTemp => docTemp.idDocumento === idDocumento);
        if (documentoTemp) {
            this.$set(this.listDocuments[index], 'documento', documentoTemp);
            this.listDocuments[index].documentoCargado = true;
        }
        console.log(this.listDocuments);
    }
    },
    deleteDocument(idDocumento){
        this.listDocuments.forEach(doc => {
            if (doc.documento && doc.documento.idDocumento === idDocumento) {
                doc.documento = null; // o doc.documento = undefined;
                doc.documentoCargado = false;
            }
        });
        this.listDocumentsTemp.forEach((docTemp, i) => {
            if (docTemp.idDocumento === idDocumento) {
                this.listDocumentsTemp.splice(i, 1);
            }
        });
    },
    async sendSolicitud(){
        let validator = true;
        this.listDocuments.map( doc => {
            if(doc.obligatorioField == 1 && !doc.documento) {
                this.$modal.show('mensaje')
                this.icono = 2
                this.title = 'Error!'
                this.text = 'Error, el documento ' + doc.nombreRequisitoField + ' es obligatorio.'
                this.classButton = 'btn btn-danger col-3'
                validator = false;
                this.actionB = false;
            }  
        })
        if(validator){
            this.isLoading = true;
            await this.validarXML()
            this.isLoading = false;

            // await this.solicitudProveedores()
        }

    },
    convertBase64(blob) {
        return new Promise((resolve, reject) => {
            var reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
            resolve(reader.result.split(",")[1]);
            };
        });
    },
    openModal(icono, title, text, clase, action){
        this.$modal.show('mensaje');
        this.icono = icono;
        this.title = title;
        this.text = text;
        this.classButton = clase; 
        this.actionB = action;
    },
    async validarXML(xmldoc) {
        let listXML = [];
        this.listDocuments.forEach(xml => {
            if (xml.documento) {
                if (xml.idField == 548 || xml.idField == 675) {
                    listXML.push(xml);
                }
            }
        });

        this.isLoading = true;
        this.xmlValidation = true; // Bandera inicialmente en true

        for (const doc of listXML) {
            const payload = {
                metodo: "VALIDARDOCUMENTOSXML",
                data: {
                    DocumentXmlBase64: await this.convertBase64(doc.documento)
                },
            };

            try {
                const response = await this.$store.dispatch("metodoPost", payload);
                if (response) {
                    const res = this.$store.getters.getRespuestaREST;
                    for (const xml of res.TransactionProperties) {
                        if (xml.keyField == 'UUID') {
                            await this.validaUUID(xml.valueField, doc.nombreRequisitoField);
                            if (!this.xmlValidation) {
                                // Salir del bucle si la validación del UUID falló
                                this.isLoading = false;
                                return;
                            }
                        }
                        if (xml.keyField == 'RFC Receptor') {
                            if (xml.valueField != 'LSE7406056F6') {
                                this.xmlValidation = false; // Establecer la bandera en false si hay un documento incorrecto
                                this.openModal(2, 'Error!', 'Error, el RFC Receptor es incorrecto.', 'btn btn-danger col-3', false);
                                this.isLoading = false;
                                return;
                            }
                        }
                        if (xml.keyField == 'RFC Emisor') this.rfcReceptor = xml.valueField;
                    }

                    if (res.ValidationResult.documentIsValid == false || res == null) {
                        let titulo = 'Error ' + doc.nombreRequisitoField;
                        let mensaje = res.ValidationResult.warningRules[0].messageField;
                        console.log(mensaje);
                        this.openModal(2, titulo, mensaje, 'btn btn-danger col-3', false);
                        this.xmlValidation = false; // Establecer la bandera en false si hay un documento incorrecto

                        break; // Salir del bucle si un documento es incorrecto
                    }

                    for (const data of res.TransactionProperties) {
                        if (data.keyField === "StatusSAT" && data.valueField != 'Vigente') {
                            this.xmlValidation = false; // Establecer la bandera en false si hay un documento incorrecto
                            this.openModal(2, 'Error!', 'El documento ' + doc.nombreRequisitoField + ' no es vigente.', 'btn btn-danger col-3', false);
                            break;
                        }
                    }
                } else {
                    console.log('error else');
                }
            } catch {
                let error = this.$store.getters.getDataRaw.errorMessage;
                this.xmlValidation = false; // Establecer la bandera en false si hay un documento incorrecto
                this.openModal(2, 'Error!', 'La estructura del Documento ' + doc.nombreRequisitoField + ' es inválida.', 'btn btn-danger col-3', false);
            }
        }

        this.isLoading = false;
        if (this.xmlValidation) {
            this.listaNegra(this.rfcReceptor);
        }
    },
    async validaUUID(uuid, doc){
        this.isLoading = true;
        const payload = {
        metodo: "VALIDAUUIDSASP",
        data: {
            JsonFiltro: '{\"UUID\":\"'+ uuid + '\"}'
            }
        };
        console.log(payload);
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                if(res != []) {
                    this.xmlValidation = false
                    this.openModal(2, 'Error!', `La ${doc} ya fue registrada anteriormente con el folio: ${res[0].Folio}. Por favor ingrese un archivo diferente para continuar con el tramite.`, 'btn btn-danger col-3', false);
                }
            } 
        } 
        catch {
            console.log('error');
        }
        this.isLoading = false;
    },
    async listaNegra(rfc){
        this.isLoading = true;
        const payload = {
        metodo: "LISTASNEGRAS",
        data: {
            rfcs: [rfc]
            }
        };
        console.log(payload);
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                if (res.results[0].encontrado == 'Si') {
                    this.openModal(2, 'Error!', 'El RFC Emisor es invalido', 'btn btn-danger col-3', false);
                    return;
                } else {
                    this.solicitudProveedores()
                }
            } else {

            }
        } 
        catch {
            console.log('error');
        }
        this.isLoading = false;
    },
    
    async solicitudProveedores(){
        let listRequisitos = []

        await Promise.all(this.listDocuments.map(async doc => {
            if (doc.documento) {
                let nombre = doc.documento.name.split('.');
                let obj = {
                    idRequisito : doc.documento.idDocumento,
                    base64 : await this.convertBase64(doc.documento),
                    nombre : nombre[0],
                    contentType : doc.documento.type,
                    extension : '.' + nombre[1]
                };
                listRequisitos.push(obj);
            }
        }));
        this.isLoading = true;
        const payload = {
        metodo: "SOLICITUDPROVEE",
        data: {
            Folio: this.folio,
            EmailAdicional: this.email,
            IdTipoTramite: this.tipoRequisito.toString(),
            UsuarioProveedor: localStorage.getItem("userId"),
            Requisitos: listRequisitos
            }
        };
        console.log(payload);
        try {
        const response = await this.$store.dispatch("metodoPost", payload);
            if (response) {
                const res = this.$store.getters.getRespuestaREST;
                
                this.$modal.show('mensaje')
                this.icono = 1
                this.title = 'Exito!'
                this.text = res
                this.classButton = 'btn btn-success col-3'
                this.actionB = true;
                
            
            } else {
                this.isLoading = false;
                this.$modal.show('mensaje')
                this.icono = 2
                this.title = 'Error!'
                this.text = 'Hubo un error al enviar la solicitud.'
                this.classButton = 'btn btn-danger col-3'
                this.actionB = false;

            }
        } 
        catch {
            this.isLoading = false;
            console.log('error');
        }
        this.isLoading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-primary{
    background-color: #1e536b !important;
    border-color: #1e536b !important;
}
.card {
    border-radius: 30px;
}
.shadow {
  box-shadow: 0px 0px 10px 0px rgba(82, 82, 82, 0.26); /* Ajusta los valores según desees */
}
</style>